const namespaced = true;
const defaultState = () => ({
  originData: [], //原始資料
  sources: [],
  dateRange: [], //日期範圍
  highchartColor: ["#ffc000", "#66bb6a", "#ed7d31", "#a5a5a5", "#5b9bd5"], // highchart color
  customerName: ["新訪客", "活躍客群", "潛在客群", "回流訪客"], // group type 翻譯

  interestDistributedReport: [], //興趣分布
  interestStructureReport: [], // 興趣結構
  populationTagsReport: [], // 母體標籤趨勢圖(日)
  weekPoupulationsTagReport: [], //母體標籤趨勢圖(週)
  date: "",

  weekDateRange: [], //七天日期範圍

  crowdTagReport: {}, // 人群貼標
  crowdTagMenu: {}, //網站貼標率，提示方框
  y: 0,
  selectedTag: {}, //所選標籤
});
const state = defaultState();

const mutations = {
  //filter所選的標籤名稱
  setSelectedTag: (state, tag) => {
    state.selectedTag = tag;
  },
  resetState: (state) => Object.assign(state, defaultState()),
  // 原始資料
  setOriginData: (state, data) => {
    state.originData = data;
  },
  // sources
  setSources: (state, sources) => (state.sources = [...sources]),
  // 日期範圍，不管有幾個 source，取第一筆資料的日期即可
  setDateRange: (state) =>
    (state.dateRange = state.originData.data.map((el) => el.date)),

  //七天日期範圍
  setWeekDateRange: (state) => {
    const allDate = state.originData.data.map((el) => el.date); //取得所有的日期
    state.weekDateRange = [];
    const dateRange = allDate.length; //總天數

    const lastCount = dateRange % 7; //不滿七天的天數

    if (lastCount != 0) {
      //先處理第一筆日期範圍
      if (lastCount == 1) {
        state.weekDateRange[0] = allDate[0].substring(5); //只剩一天
      } else {
        state.weekDateRange[0] =
          allDate[0].substring(5) + "~" + allDate[lastCount - 1].substring(5); //剩2~6天的日期範圍
      }
    }
    if (dateRange % 7 == 0) {
      state.weekDateRange[0] =
        allDate[0].substring(5) + "~" + allDate[6].substring(5); //剛好滿七天
    }

    let dateIndex = lastCount; //從第一筆範圍以後的日期開始

    let weekDateRangeIndex; //從第一筆以後開始
    if (lastCount == 0) {
      weekDateRangeIndex = 0;
    } else {
      weekDateRangeIndex = 1;
    }
    if (dateRange.length != 7) {
      while (dateIndex < dateRange) {
        state.weekDateRange[weekDateRangeIndex] =
          allDate[dateIndex].substring(5) +
          "~" +
          allDate[dateIndex + 6].substring(5);
        dateIndex += 7;
        weekDateRangeIndex++;
      }
    }
  },

  setDistinctCount: (state) => {
    state.distinctCount =
      // index > -1
      // ? state.originData.group[index].acc_distinct_count
      // : state.originData.group.reduce(
      //   (preCount, curObj) => (preCount += parseInt(curObj.acc_distinct_count)),
      //   0
      //   );

      state.originData.data.reduce(
        (preCount, curObj) =>
          (preCount += curObj.group.reduce(
            (preCount, curObj) =>
              parseInt((preCount += curObj.all_distinct_count)),
            0
          )),
        0
      );

    state.y = state.originData.data.reduce(
      (preCount, curObj) =>
        (preCount += curObj.group.reduce(
          (preCount, curObj) => parseInt((preCount += curObj.distinct_count)),
          0
        )),
      0
    );
    // index > -1
    // ? state.originData.group[index].distinct_count
    // : state.originData.group.reduce(
    //       (preCount, curObj) => (preCount += parseInt(curObj.distinct_count)),
    //       0
    //     );
    // console.log("acc_distinct_count",sacc_distinct_count)
  },

  // 人群貼標
  setCrowdTagReport: (state, { category, color, y } = {}) => {
    // 若無指定參數，取單日興趣分布第一筆

    const { distinctCount } = state;

    if (distinctCount == undefined) {
      return (state.crowdTagReport.data = []);
    }

    category = state.selectedTag;

    y = state.y;

    state.crowdTagReport = {
      subtitle: `不重複瀏覽人數 : ${distinctCount.toLocaleString()} 人`,
      ratio: (y / distinctCount) * 100, //(y / distinctCount) * 100

      data: [
        {
          name: category,
          y: y, //y
          color: color,
        },
        {
          name: "其他標籤",
          y: distinctCount - y,
          color: "#DDDDDD",
        },
      ],
    };
  },

  setCrowdTagMenu: (state, { name, data } = {}) => {
    state.crowdTagMenu.name = name;
    state.crowdTagMenu.data = data;
  },
  // 興趣結構 + 興趣分布
  setInterestReport: (state) => {
    const distributedData = [];
    const structureData = [];
    // 攤平資料
    const concatAllTags = state.originData.data.reduce(
      (dataObj, curdataObj) =>
        dataObj.concat(
          curdataObj.group.reduce(
            (groupObj, curgroupObj) =>
              groupObj.concat(
                curgroupObj.tags.reduce(
                  (tagObj, curtagObj) => tagObj.concat(curtagObj),
                  []
                )
              ),
            []
          )
        ),
      []
    );
    // 計算興趣分布 (重複標籤加總)
    concatAllTags.forEach((item) => {
      const { type, subject, count } = item;
      const currentName = `${type}:${subject}`;
      const existData = distributedData.find(
        (e) => `${e.type}:${e.subject}` === currentName
      );
      existData
        ? (existData.count += parseInt(count))
        : distributedData.push({
            type: type,
            subject: subject,
            count: parseInt(count),
            color: [],
          });
    });

    // 興趣分布排序
    distributedData.sort((a, b) => b.count - a.count);
    // distributedData.unshift(distributedData[33]);
    // console.log(distributedData[18]);
    //建立顏色表
    var color = [
      "#F94144",
      "#F3722C",
      "#F8961E",
      "#F9844A",
      "#F9C74F",
      "#90BE6D",
      "#43AA8B",
      "#4D908E",
      "#577590",
      "#277DA1",
      "#455E89",
      "#5C4D7D",
      "#723C70",
      "#892B64",
      "#A01A58",
    ];

    // 計算興趣結構 (重複 type 取 count 最大值)
    var tempArr = [...distributedData];
    //若搜尋標籤無資料，則給空資料，不然HTML會ERROR
    if (distributedData.length != 0) {
      for (let index = 0; index < tempArr.length; index++) {
        //切割類別排名圖的頭到尾資料，第一個為所選標籤
        if (
          state.originData.tag.substring(1, state.originData.tag.length - 1) ===
          tempArr[index].subject
        ) {
          tempArr = tempArr.slice(index, tempArr.length);
          break;
        }
      }

      let i = 0;
      while (tempArr.length > 0 && structureData.length < 15) {
        const item = tempArr.shift();

        const typeCompare = (el) => el.type === item.type;
        const exists = structureData.some(typeCompare);
        if (!exists) {
          //設定不重複類別的顏色
          item.color = color[i];
          structureData.push(item);
          i++;
        }
      }
      state.interestStructureReport = structureData;
    } else {
      state.interestStructureReport = [];
    }
    //取興趣標籤排名前15筆資料
    var distributedDataFinally;
    //若搜尋標籤無資料，則給空資料，不然HTML會ERROR
    if (distributedData.length != 0) {
      for (let index = 0; index < distributedData.length; index++) {
        //切割標籤排名圖的頭到尾資料，第一個為所選標籤
        if (
          state.originData.tag.substring(1, state.originData.tag.length - 1) ===
          distributedData[index].subject
        ) {
          distributedDataFinally = distributedData.slice(index, index + 14);
          break;
        } else {
          distributedDataFinally = distributedData.slice(0, 15);
        }
      }
      let dataType = [];
      for (let j = 0; j < distributedDataFinally.length; j++) {
        //取每筆興趣標籤排名的Type(類別)
        dataType[j] = distributedDataFinally[j].type;
        for (let k = 0; k < dataType.length; k++) {
          //判斷當筆的Type(類別)是否有重複
          if (dataType[j] == dataType[k]) {
            //若Type(類別)有重複，將當筆與重複筆的資料Color設為相同
            distributedDataFinally[j].color = distributedDataFinally[k].color;
          }
        }
      }

      // 資料取前 15，興趣結構在 while 已處理
      state.interestDistributedReport = distributedDataFinally;
    } else {
      state.interestDistributedReport = [];
    }
  },
  // 母體標籤趨勢圖
  setPopulationTagsReport: (state, tagName = "") => {
    if (!tagName && state.interestStructureReport.length != 0) {
      const [{ type, subject } = {}] = state.interestStructureReport;
      if (!type) {
        //無資料
        return (state.populationTagsReport = { series: [{ data: [] }] });
      }
      tagName = `${type}:${subject}`;
    }
    // 每天指定標籤總和、指定標籤母體，不分 group
    const source1 = state.originData.data.map((groupData) => {
      return {
        //母體標籤 population_tags
        population: (() => {
          const existPupulationObj = groupData.population_tags.find(
            (e) => `${e.type}:${e.subject}` === tagName
          );
          return existPupulationObj ? existPupulationObj.count : 0;
        })(),
        //日滾動標籤 acc_tags
        tagCount: groupData.group.reduce(
          (groupCount, curObj) =>
            groupCount +
            // curObj.tags.reduce(
            curObj.tags.reduce(
              (oldTagCount, curTag) =>
                `${curTag.type}:${curTag.subject}` === tagName
                  ? (oldTagCount += parseInt(curTag.count))
                  : oldTagCount,
              0
            ),
          0
        ),
      };
    });

    var startPoint;
    //從尾開始往前，將每日source轉成7天一筆的weekSource
    const getWeekSource = (source) => {
      if (source != undefined) {
        //只選一個source時，source1有資料，source2為undefined
        var weekSource = []; //7天為一單位的source
        var sourceIndex = source.length - 1;
        var weekSourceIndex = 0;
        var lastFewDays = 0;

        while (sourceIndex >= 0) {
          var weekPoupulations = 0;
          var weekTagCount = 0;
          if (source[sourceIndex - 7] != undefined) {
            //確認7天前還有資料
            for (var i = 0; i < 7; i++) {
              //統計滿7天的資料之population、tagcount
              weekPoupulations =
                weekPoupulations + source[sourceIndex - i].population;
              weekTagCount = weekTagCount + source[sourceIndex - i].tagCount;
            }
            sourceIndex -= 7;
            weekPoupulations = Math.round(weekPoupulations / 7);
            weekTagCount = Math.round(weekTagCount / 7);
          } else {
            while (sourceIndex >= 0) {
              //統計不滿7天的資料之population、tagCount
              weekPoupulations =
                weekPoupulations + source[sourceIndex].population;
              weekTagCount = weekTagCount + source[sourceIndex].tagCount;
              sourceIndex -= 1;
              lastFewDays++;
            }
            weekPoupulations = Math.round(weekPoupulations / lastFewDays);
            weekTagCount = Math.round(weekTagCount / lastFewDays);
          }

          //儲存7天一筆的資料(因為不知長度，所以先以反向做儲存)
          weekSource[weekSourceIndex] = {
            population: weekPoupulations,
            tagCount: weekTagCount,
          };
          weekSourceIndex++;
        }

        startPoint = lastFewDays - 1; //
        const weekSourceRev = weekSource.reverse(); //反轉成正向

        return weekSourceRev;
      }
    };

    //標籤數，多 source 合併計算
    const tagCount = (index, optionName, source1, source2) => {
      // source2
      //     ? source1[index][optionName] + source2[index][optionName]
      //     : source1[index][optionName];
      if (source2 !== undefined) {
        return source1[index][optionName];
      } else {
        return source1[index][optionName];
      }
    };
    //成長率公式 : (本周數量 - 上週數量) / 上周數量，多 source 合併計算
    //成長率差 : 搜尋結果成長率-母體標籤成長率

    const growthRate = (index, source1) => {
      if (index < 1) {
        return;
      } //第一筆不計算
      const thisPopulation = tagCount(index, "population", source1);
      const lastPopulation = tagCount(index - 1, "population", source1);

      const thisCount = tagCount(index, "tagCount", source1);
      const lastCount = tagCount(index - 1, "tagCount", source1);

      return parseFloat(
        (
          (thisCount - lastCount) / lastCount -
          (thisPopulation - lastPopulation) / lastPopulation
        ).toFixed(2)
      );
    };

    const report = {
      subtitle: tagName,
      series: [],
    };
    const weekReport = {
      subtitle: tagName,
      series: [],
    };

    //將美日資料轉成每周資料
    const weekSource1 = getWeekSource(source1);

    report.series.push(
      {
        yAxis: 0,
        data: source1.map((el, index) => ({
          y: tagCount(index, "tagCount", source1),
          // labels:tagCount(index, 'tagCount', source1,)? growthRate(index, source1,) : "無",
        })),
        type: "column",
        name: "日貼標數",
        color: "#e3ad88",
        pointInterval: 1, //1天一個點
      },
      {
        yAxis: 1,
        data: source1.map((el, index) => ({
          y:
            growthRate(index, source1) != undefined
              ? growthRate(index, source1)
              : null,
          labels: growthRate(index, source1)
            ? growthRate(index, source1)
            : "無",
        })),

        name: "日成長率差",
        color: "#6C6C6C",
        pointInterval: 1, //1天一個點
      }
    );

    weekReport.series.push(
      {
        yAxis: 0,
        data: weekSource1.map((el, index) => ({
          y: tagCount(index, "tagCount", weekSource1),
          // labels: growthRate(index, weekSource1,) == undefined ? growthRate(index, weekSource1,) : "無",
          dateRange: state.weekDateRange[index],
        })),
        type: "column",
        name: "週平均貼標數",
        // color:"#c4c4c4",
        color: "#e3ad88",
        pointStart: startPoint, //從指定index開始
        pointInterval: 7, //7天一個點
      },
      {
        yAxis: 1,
        data: weekSource1.map((el, index) => ({
          y:
            growthRate(index, weekSource1) != undefined
              ? growthRate(index, weekSource1)
              : null, //tagCount(index, 'tagCount', weekSource1, weekSource2),
          labels: growthRate(index, weekSource1)
            ? growthRate(index, weekSource1)
            : "無",
          dateRange: state.weekDateRange[index],
        })),
        name: "週平均成長率差",
        color: "#6C6C6C",
        pointStart: startPoint, //從指定index開始
        pointInterval: 7, //7天一個點
      }
    ),
      (state.populationTagsReport = report);
    state.weekPoupulationsTagReport = weekReport;
  },
};

const actions = {
  setSelectedTag: ({ commit }, tag) => {
    commit("setSelectedTag", tag);
  },

  setOriginData: ({ commit }, data) => {
    //set origindata
    commit("setOriginData", data);
    commit("setDateRange");
    commit("setInterestReport");
    commit("setWeekDateRange");
    commit("setPopulationTagsReport");
    commit("setSelectedTag", state.selectedTag); //test

    commit("setDistinctCount");

    commit("setCrowdTagMenu"); //test
    commit("setCrowdTagReport");
  },
};
const getters = {
  getDataSources: (state) => state.sources, // sources
  getDateRange: (state) => state.dateRange, // 日期範圍
  getWeekDateRange: (state) => state.weekDateRange, //七天日期範圍
  getInterestDistributed: (state) => state.interestDistributedReport, //興趣分布
  getInterestStructure: (state) => state.interestStructureReport, //興趣結構
  getPopulationTags: (state) => state.populationTagsReport, // 母體標籤
  getWeekPoupulationsTagReport: (state) => state.weekPoupulationsTagReport, // 母體標籤
  getDate: (state) => state.originData.date, //date

  getCrowdTag: (state) => state.crowdTagReport, // 人群貼標
  getCrowdTagMenu: (state) => state.crowdTagMenu, //提示框
};

export default { namespaced, state, actions, mutations, getters };
